import type { welcome as en } from "../en/welcome";
import type { Messages } from "../types";

/** الصفحة الترحيبية العامة على / (ALP-85). */
export const welcome: Messages<typeof en> = {
  meta: { title: "ملفك" },
  skip: "تخطَّ إلى المحتوى",
  nav: {
    label: "الأقسام",
    features: "المزايا",
    how: "كيف يعمل",
    plans: "الخطط",
    faq: "الأسئلة الشائعة",
    login: "تسجيل الدخول",
    signup: "إنشاء حساب",
    menu: "فتح القائمة",
    menuTitle: "القائمة",
    language: "English",
    themeLight: "التبديل إلى المظهر الفاتح",
    themeDark: "التبديل إلى المظهر الداكن",
  },
  hero: {
    eyebrow: "إدارة التواصل الاجتماعي بالذكاء الاصطناعي · إنستغرام",
    title: "كل تعليق ورسالة يجدان ردًّا،",
    titleAccent: "بصوت علامتك التجارية.",
    text: "يجمع ملفك تعليقات إنستغرام ورسائله في صندوق وارد واحد مباشر. الذكاء الاصطناعي يصنّف ويقترح الردود، وقواعدك تحدّد ما يحدث، وشخص من فريقك يوافق متى كان الأمر مهمًّا. بالعربية أولًا، وبالإنجليزية أيضًا.",
    cta: "اطلب الوصول",
    secondary: "تسجيل الدخول",
    note: "الطلب مجاني، ونتواصل شخصيًّا مع كل فريق جديد.",
    points: { arabic: "عربي وإنجليزي، واتجاه من اليمين إلى اليسار كما يجب", approvals: "لا يتصرّف الذكاء الاصطناعي دون قواعدك أو موافقتك", lost: "لا يضيع شيء: التعليقات المحذوفة تبقى في منصة ملفك" },
  },
  demo: {
    label: "معاينة حيّة لصندوق وارد منصة ملفك: تصل التعليقات الجديدة مصنّفة في فئات ذكية، وينتظر ردّ مقترح الموافقة.",
    inbox: "الوارد",
    live: "مباشر",
    intents: { price: "سؤال عن السعر", praise: "إشادة", spam: "رسائل مزعجة", order: "طلب" },
    sentiment: { positive: "إيجابي", neutral: "محايد", negative: "سلبي" },
    hidden: "أُخفي بقاعدة",
    draft: "مسودة ذكية",
    approve: "موافقة",
    approved: "تمت الموافقة والإرسال",
    replies: "الردود هذا الأسبوع",
    response: "متوسط زمن الرد الأول",
  },
  features: {
    eyebrow: "ماذا يقدّم ملفك",
    title: "مكان واحد لمحادثات علامتك على وسائل التواصل",
    text: "مصمَّم لفرق الشرق الأوسط التي تبيع وتخدم عملاءها في تعليقات إنستغرام ورسائله.",
    items: {
      inbox: { title: "صندوق الوارد والإشراف", text: "التعليقات والرسائل من كل الحسابات في قائمة واحدة، مع فئات ذكية للنية والمشاعر والإساءة. ردّ أو أخفِ أو أضف وسمًا أو نفّذ إجراءً جماعيًّا في ثوانٍ." },
      agents: { title: "وكلاء ذكيون وردود تلقائية", text: "ردود مقترحة بنبرة علامتك. كل قاعدة تعمل تلقائيًّا، أو تطلب الموافقة أولًا، أو تقترح فقط." },
      copilot: { title: "المساعد", text: "اسأل بالعربية أو الإنجليزية واحصل على رسوم وجداول وقوائم تعليقات حيّة. يقترح التغييرات ويؤكّدها شخص من فريقك." },
      dashboards: { title: "لوحات حيّة", text: "لوحات قابلة للتعديل تبقى عناصرها محدّثة، لكل حساب ولكل منشور، مع أفضل أوقات النشر." },
      calendar: { title: "ذكاء التقويم", text: "الأيام الوطنية والدينية والعالمية لكل دولة، مع إرشادات المزاج والنبرة وتنبيهات التعارض." },
      c360: { title: "ملف العميل الشامل", text: "خط زمني واحد لكل شخص عبر التعليقات والردود والرسائل، مع ملاحظات وتصنيفات مثل مميّز أو مسيء." },
      rules: { title: "قواعد الأتمتة", text: "الشروط البسيطة أولًا والذكاء الاصطناعي عند الحاجة فقط: كلمات وروابط ولغة ومعلّقون معلَّمون. جرّب القاعدة قبل تفعيلها." },
    },
  },
  how: {
    eyebrow: "كيف يعمل",
    title: "من تعليق جديد إلى قرار، في أربع خطوات",
    steps: {
      connect: { title: "اربط إنستغرام", text: "سجّل الدخول عبر تسجيل الدخول الرسمي من إنستغرام، ويستورد ملفك منشوراتك وتعليقاتك ورسائلك." },
      triage: { title: "الذكاء الاصطناعي يفرز", text: "كل تعليق ورسالة جديدة تُصنَّف وتُرتَّب حسب الأولوية، ويُقترح لها رد عندما تطلب القاعدة ذلك." },
      approve: { title: "أنت توافق", text: "الإجراءات الحساسة والمسودات الذكية تنتظر في الموافقات. عدّل أو وافق أو ارفض؛ لا يُرسل شيء وحده." },
      insights: { title: "رؤى", text: "اللوحات والتحليلات والمساعد تُظهر ما يسأل عنه الناس، وسرعة ردّك، وما ينجح." },
    },
  },
  plans: {
    eyebrow: "الخطط",
    title: "خطة لكل مرحلة",
    text: "نُعدّ الخطة معك عند الموافقة على طلبك.",
    price: "تواصل معنا",
    cta: "اطلب الوصول",
    items: {
      trial: { name: "تجريبية", text: "كل ما في الاحترافية لمدة 14 يومًا، ثم المجانية." },
      free: { name: "مجانية", text: "حساب واحد، والأساسيات." },
      pro: { name: "احترافية", text: "للعلامات التجارية النامية: المساعد واللوحات والإشراف الجماعي." },
      business: { name: "أعمال", text: "للفرق والوكالات: كل شيء، وحدود سخية." },
    },
  },
  trust: {
    eyebrow: "الثقة والأمان",
    title: "القرار بيدك",
    items: {
      approval: { title: "موافقة بشرية", text: "الذكاء الاصطناعي يصنّف ويكتب المسودات ويقترح، وقواعدك وفريقك يقرّرون ما يُرسل." },
      login: { title: "تسجيل دخول رسمي من إنستغرام", text: "تُربط الحسابات عبر تسجيل الدخول الخاص بإنستغرام، ولا نطلب كلمة مرورك ولا نراها." },
      audit: { title: "كل شيء مسجَّل", text: "لكل تشغيل أتمتة خط زمني، وكل تغيير من فريق ملفك يُكتب في سجل التدقيق." },
      deletion: { title: "بياناتك قرارك", text: "صدّر بيانات أي شخص أو امسحها، واختر مدة الاحتفاظ، واطلب الحذف الكامل في أي وقت." },
      arabic: { title: "العربية أولًا", text: "قواعد تفهم اللهجات وتوحّد أشكال الحروف والأرقام العربية، فتلتقط القاعدة الواحدة طريقة الكتابة الحقيقية." },
    },
  },
  faq: {
    eyebrow: "الأسئلة الشائعة",
    title: "أسئلة وأجوبة",
    items: {
      what: { q: "ما هو ملفك؟", a: "منصة ملفك مكان واحد لقنوات علامتك على وسائل التواصل: صندوق وارد مباشر، وأتمتة مع موافقات، ونشر، ولوحات، وذكاء التقويم، ومساعد ذكي." },
      channels: { q: "ما القنوات المدعومة؟", a: "حسابات إنستغرام الاحترافية (أعمال أو صانع محتوى) حاليًّا. صفحات فيسبوك وماسنجر وواتساب قريبًا." },
      ai: { q: "هل يردّ الذكاء الاصطناعي وحده؟", a: "فقط إذا كتبت قاعدة تسمح بذلك. كل قاعدة تعمل تلقائيًّا أو تنتظر الموافقة أو تقترح فقط، ويمكنك دائمًا إشراك شخص من فريقك." },
      arabic: { q: "هل يعمل بالعربية؟", a: "نعم. التطبيق كله يعمل بالعربية والإنجليزية، من اليمين إلى اليسار ومن اليسار إلى اليمين، بالمظهرين الفاتح والداكن." },
      access: { q: "كيف أحصل على الوصول؟", a: "اضغط إنشاء حساب وأخبرنا عن نشاطك التجاري وسبب رغبتك في استخدام ملفك. نراجع كل طلب ونتواصل معك." },
      pricing: { q: "كم التكلفة؟", a: "تواصل معنا. نُعدّ الخطة المناسبة لفريقك عند الموافقة على طلبك، ويمكنك البدء بالخطة التجريبية." },
      deletion: { q: "هل يمكنني حذف بياناتي؟", a: "نعم. يمكنك مسح بيانات أي شخص من ملفه، وطلب حذف كل شيء من صفحة حذف البيانات." },
    },
  },
  cta: { title: "مستعد للرد على كل عميل بشكل أسرع؟", text: "أخبرنا عن علامتك التجارية وسنعود إليك.", button: "اطلب الوصول" },
  footer: {
    tagline: "إدارة التواصل الاجتماعي بالذكاء الاصطناعي، بالعربية أولًا.",
    product: "المنتج",
    legal: "قانوني",
    account: "الحساب",
    privacy: "الخصوصية",
    terms: "الشروط",
    deletion: "حذف البيانات",
    contact: "لديك أسئلة؟ اطلب الوصول وأخبرنا بما تحتاجه؛ نردّ على كل طلب.",
    founder: "المؤسس",
    linkedinCompany: "ملفك على لينكدإن",
    linkedinFounder: "المؤسس على لينكدإن",
  },
};
